exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-link[data-v-42b6bba9]{cursor:pointer}", ""]);

// exports
